import React from 'react';

function ProfileRequirements() {
  return <div>ProfileRequirements</div>;
}

export default ProfileRequirements;
